import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope, FaTwitter } from "react-icons/fa";


const Footer = () => {
  return (
    <div className="flex justify-center w-full">
  <a href="https://mail.google.com/mail/?view=cm&fs=1&to=pilarebhushan4@gmail.com&su=Hello&body=Hi%20there!" target="_blank" rel="noopener noreferrer">
    <button className="border-r px-10">
      <FaEnvelope size={24} />
    </button>
  </a>
  <a href="https://github.com/Bhushan-04" target="_blank" rel="noopener noreferrer">
    <button className="border-r px-10">
      <FaGithub size={24} />
    </button>
  </a>
  <a href="https://www.linkedin.com/in/bhushan-pilare-4a7713154/" target="_blank" rel="noopener noreferrer">
    <button className="border-r px-10">
      <FaLinkedin size={24} />
    </button>
  </a>
  <a href="https://x.com/Bhushann_S" target="_blank" rel="noopener noreferrer">
    <button className="px-10">
      <FaTwitter size={24} />
    </button>
  </a>
</div>

  )
}

export default Footer;